import "../scss/style.scss";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import "./top.js";

const FADEUP_BUFFER = 80;

/** 固定ヘッダー（.header.js-header-sp）の高さ */
function getStickyHeaderOffset() {
  const $header = $('.header.js-header-sp').first();
  if (!$header.length) return 0;
  return Math.round($header.outerHeight() || 0);
}

function normalizePathname(pathname) {
  const p = pathname.replace(/\/+$/, '');
  return p === '' ? '/' : p;
}

/**
 * 同一ページ内アンカーなら #〜 を返す。別URL・別オリジンは null
 */
function getSamePageHashFromHref(href) {
  if (!href || href === '#') return null;
  const trimmed = href.trim();
  if (/^(javascript:|mailto:|tel:)/i.test(trimmed)) return null;

  let hash;
  if (trimmed.charAt(0) === '#') {
    hash = trimmed;
  } else {
    try {
      const u = new URL(trimmed, window.location.href);
      if (u.origin !== window.location.origin) return null;
      if (normalizePathname(u.pathname) !== normalizePathname(window.location.pathname)) {
        return null;
      }
      if (u.search !== window.location.search) return null;
      hash = u.hash;
    } catch (err) {
      return null;
    }
  }
  if (!hash || hash === '#') return null;
  return hash;
}

/**
 * id 要素へスクロール（ヘッダー分を差し引く）。getElementById で安全に解決
 */
function scrollToHashTarget(hash, smooth) {
  const id = hash.replace(/^#/, '');
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  const top = $(el).offset().top;
  const y = Math.max(0, top - getStickyHeaderOffset());
  window.scrollTo({
    top: y,
    behavior: smooth ? 'smooth' : 'auto',
  });
  return true;
}

const updateScroll = () => {
  const scrollPosition = window.scrollY || window.pageYOffset;
  if (scrollPosition > 100) {
    $('.totop').fadeIn();
  } else {
    $('.totop').fadeOut();
  }
  $(".js-fadeUp").each(function () {
    const target = $(this);
    const targetOffset = target.offset().top;
    const windowHeight = $(window).height();
    const showThreshold = targetOffset - windowHeight;
    const hideThreshold = showThreshold - FADEUP_BUFFER;
    if (scrollPosition > showThreshold) {
      target.addClass("is-fadeUp");
    } else if (scrollPosition < hideThreshold) {
      target.removeClass("is-fadeUp");
    }
  });
};

$(window).on("load scroll", updateScroll);

// 同一ページの #〜 および /path/#〜（採用ヘッダー等）をスムーズスクロール＋ヘッダー分オフセット
$(document).on('click', 'a[href*="#"]', function (e) {
  if (window.innerWidth <= 767 && $(this).closest('.has-sub').length) {
    return;
  }
  const hash = getSamePageHashFromHref($(this).attr('href'));
  if (!hash) return;
  const id = hash.replace(/^#/, '');
  if (!document.getElementById(id)) return;

  e.preventDefault();
  scrollToHashTarget(hash, true);

  $('.js-nav-content, .js-nav-logo, .js-header-sp, .js-nav-bt').removeClass('is-navOn');

  if (history.pushState) {
    history.pushState(
      null,
      '',
      `${window.location.pathname}${window.location.search}${hash}`,
    );
  }
});

// 直リンク・リロードで /recruit/#recruitSec01 等が開いたとき、ヘッダー分を考慮して位置補正
function fixScrollPositionForHashOnLoad() {
  const hash = window.location.hash;
  if (!hash) return;
  const id = hash.replace(/^#/, '');
  if (!id || !document.getElementById(id)) return;
  requestAnimationFrame(function () {
    scrollToHashTarget(hash, false);
  });
}

$(function () {
  $(window).on("load", updateScroll);
});
$(window).on('load', fixScrollPositionForHashOnLoad);

$(document).ready(function () {

  const $navTargets = $('.js-nav-content, .js-nav-logo, .js-header-sp, .js-nav-bt');

  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function () {
    $navTargets.toggleClass('is-navOn');
  });

  // リンククリック時の処理
  $('.js-nav-link').on('click', function (e) {
    const parent = $(this).closest('.header-navList__link');

    // SPで下層メニューを持つ場合はアコーディオン
    if (window.innerWidth <= 767 && parent.hasClass('has-sub')) {
      e.preventDefault();
      parent.toggleClass('is-open');
      return;
    }

    // それ以外はメニューを閉じる
    $navTargets.removeClass('is-navOn');
  });

});

// FAQアコーディオンメニュー
$(function () {
  $(".js-accordion-title").on("click", function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass("open", 300);
  });

  $(".js-footer-accordion-title").on("click", function (e) {
    if (window.innerWidth <= 767) {
      e.preventDefault();
      $(this).next().slideToggle(300);
      $(this).toggleClass("open", 300);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // 民泊運営事例一覧ページ用（471px固定・左右はみ出し）
  const caseMvSlide = document.querySelector('.js-case-mv-slide');
  if (caseMvSlide) {
    new Swiper('.js-case-mv-slide', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 2,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      grabCursor: true,
      watchSlidesProgress: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.js-case-mv-slide .swiper-button-next',
        prevEl: '.js-case-mv-slide .swiper-button-prev',
      },
      pagination: {
        el: ".js-case-mv-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 'auto',
          spaceBetween: 16,
          centeredSlides: false,
        },
        1025: {
          slidesPerView: 'auto',
          spaceBetween: 35,
          centeredSlides: true,
        }
      },
    });
  }

  // その他ページの js-case-slide（事例スライダー共通クラス）
  const otherCaseSlide = document.querySelector('.js-case-slide');
  if (otherCaseSlide) {
    new Swiper('.js-case-slide', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.js-case-slide .swiper-button-next',
        prevEl: '.js-case-slide .swiper-button-prev',
      },
      pagination: {
        el: ".js-case-slide .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 35,
        }
      },
    });
  }

  // 事例記事ページ「W vacation の解決策」画像スライダー（1枚1000px・左右を少し表示してグレーアウト）
  const caseSingleSlide = document.querySelector('.js-case-single-slide');
  if (caseSingleSlide) {
    new Swiper('.js-case-single-slide', {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      speed: 500,
      grabCursor: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.js-case-single-slide .swiper-button-next',
        prevEl: '.js-case-single-slide .swiper-button-prev',
      },
    });
  }

  // 事例記事ページ「関連事例」3件表示スライダー（ドットページネーション付き）
  const caseSingleSec06Slide = document.querySelector('.js-case-single-sec06-slide');
  if (caseSingleSec06Slide) {
    new Swiper('.js-case-single-sec06-slide', {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      speed: 500,
      grabCursor: true,
      centeredSlides: true,
      navigation: {
        nextEl: '.caseSingleSec06-nav__next',
        prevEl: '.caseSingleSec06-nav__prev',
      },
      pagination: {
        el: '.js-case-single-sec06-pagination',
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 'auto',
          spaceBetween: 16,
          centeredSlides: true,
        },
        1025: {
          slidesPerView: 'auto',
          spaceBetween: 24,
          centeredSlides: true,
        },
      },
    });
  }

  // 物件情報記事ページ ギャラリー（ヒーロー画像と連動）
  const propertySingleGallery = document.querySelector('.js-property-single-gallery');
  if (propertySingleGallery) {
    const heroImg = document.querySelector('.propertySingle-heroArea__img');
    const propertySingleSwiper = new Swiper('.js-property-single-gallery', {
      modules: [Pagination],
      slidesPerView: 1.08,
      spaceBetween: 10,
      loop: true,
      speed: 500,
      grabCursor: true,
      slideToClickedSlide: true,
      pagination: {
        el: '.js-property-single-gallery-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
      on: {
        init(swiper) {
          if (heroImg) updatePropertyHeroImg(swiper, heroImg);
        },
        slideChange(swiper) {
          if (heroImg) updatePropertyHeroImg(swiper, heroImg);
        },
      },
    });
    function updatePropertyHeroImg(swiper, heroEl) {
      const slide = swiper.slides[swiper.activeIndex];
      const img = slide ? slide.querySelector('img') : null;
      if (img && img.src) heroEl.src = img.src;
    }
  }
});

let minpakuSec07Swiper;

function initMinpakuSec07Swiper() {
  if (window.innerWidth <= 768 && !minpakuSec07Swiper) {
    minpakuSec07Swiper = new Swiper('.minpakuSec07-swiper', {
      modules: [Pagination, Autoplay],
      slidesPerView: 1.2,
      spaceBetween: 15,
      loop: false,
      autoHeight: false,

      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },

      pagination: {
        el: '.minpakuSec07-swiper .swiper-pagination',
        clickable: true,
      },
    });
  } else if (window.innerWidth > 768 && minpakuSec07Swiper) {
    minpakuSec07Swiper.destroy(true, true);
    minpakuSec07Swiper = undefined;
  }
}

window.addEventListener('load', initMinpakuSec07Swiper);
window.addEventListener('resize', initMinpakuSec07Swiper);


let minpakuSec08Swiper;

function initMinpakuSec08Swiper() {
  if (window.innerWidth <= 768 && !minpakuSec08Swiper) {
    minpakuSec08Swiper = new Swiper('.minpakuSec08-swiper', {
      modules: [Pagination, Autoplay],
      slidesPerView: 1.3,
      spaceBetween: 24,
      loop: false,

      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  } else if (window.innerWidth > 768 && minpakuSec08Swiper) {
    minpakuSec08Swiper.destroy(true, true);
    minpakuSec08Swiper = undefined;
  }
}

window.addEventListener('load', initMinpakuSec08Swiper);
window.addEventListener('resize', initMinpakuSec08Swiper);
